<template>
  <button class="btn-aparelho" @click="handleGetModelo" type="button">
    <slot />
  </button>
</template>

<script>
import EventBus from '@/event-bus';

export default {
  name: 'ButtonSlider',
  props: {
    name: {
      type: String,
      required: true,
    },
    model: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  methods: {
    handleGetModelo() {
      const { name, params, model } = this;
      EventBus.$emit('tb-action', { modelo: model, action: 'slider' });
      this.$router.push({
        name,
        params,
      });
    },
  },
  mounted() {
    console.log(this.model);
  },
};
</script>
<style lang="scss" scoped>
.btn-aparelho {
  font-family: 'OpenSans';
  background-size: 100%;
  background-image: linear-gradient(transparent, transparent);
  background: transparent;
  border-radius: 5px;
  border: 1px solid rgba(white, 0.2);
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 1vw;
  font-weight: bold;
  padding: 5px 15px;
  position: relative;
  z-index: 100;
  -webkit-animation: shake-top 1.2s cubic-bezier(0.645, 0.045, 0.355, 1) 1s 5
    both;
  animation: shake-top 1.2s cubic-bezier(0.645, 0.045, 0.355, 1) 1s 5 both;
  transition: opacity 0.7s;

  @media (max-width: 976px) {
    font-size: 2vw;
  }

  &:before {
    border-radius: inherit;
    background-image: linear-gradient(45deg, transparent 45%, #4f0373 100%);
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    z-index: -100;
  }

  &:hover {
    &:before {
      opacity: 1;
    }
  }
}

@-webkit-keyframes shake-top {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transform-origin: 50% 0;
    transform-origin: 50% 0;
  }
  10% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    -webkit-transform: rotate(-4deg);
    transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    -webkit-transform: rotate(4deg);
    transform: rotate(4deg);
  }
  80% {
    -webkit-transform: rotate(-2deg);
    transform: rotate(-2deg);
  }
  90% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
}
@keyframes shake-top {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transform-origin: 50% 0;
    transform-origin: 50% 0;
  }
  10% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    -webkit-transform: rotate(-4deg);
    transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    -webkit-transform: rotate(4deg);
    transform: rotate(4deg);
  }
  80% {
    -webkit-transform: rotate(-2deg);
    transform: rotate(-2deg);
  }
  90% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
}
</style>
